// extracted by mini-css-extract-plugin
export default {"user-group-type-badge":"UserGroupTypeBadge_user-group-type-badge__mq6GJ"};